import CompetitivenessGeneralDashboard from './CompetitivenessGeneralDashboard'

export default CompetitivenessGeneralDashboard



// WEBPACK FOOTER //
// ./src/pages/CompetitivenessGeneralDashboard/index.js